// extracted by mini-css-extract-plugin
export default {"indicator-positive":"Indicator_indicator-positive__XcMRi","indicator-negative":"Indicator_indicator-negative__4tIc4"};